import { useEffect, useRef } from 'react';

export function usePolling(fn: () => Promise<boolean>, intervalMs: number): void {
  const fnRef = useRef(fn); fnRef.current = fn;
  useEffect(() => {
    let active = true; let inFlight = false;
    const tick = async () => { if (!active || inFlight) return; inFlight = true;
      try { if (!(await fnRef.current())) { active = false; clearInterval(id); } } finally { inFlight = false; } };
    void tick();
    const id = setInterval(tick, intervalMs);
    return () => { active = false; clearInterval(id); };
  }, [intervalMs]);
}
